/**
 * Mixin for timezone support in race analyzer components
 */
import { formatToLocalTime, formatToLocalDateTime, getTimezoneLabel, DEFAULT_TIMEZONE } from '../utils/timezone'

export default {
  props: {
    timezone: {
      type: String,
      default: DEFAULT_TIMEZONE,
    },
  },
  methods: {
    /**
     * Format timestamp to local time
     * @param {string|Date} timestamp
     * @returns {string}
     */
    formatLocalTime(timestamp) {
      return formatToLocalTime(timestamp, this.timezone)
    },

    /**
     * Format timestamp to local date and time
     * @param {string|Date} timestamp
     * @returns {string}
     */
    formatLocalDateTime(timestamp) {
      return formatToLocalDateTime(timestamp, this.timezone)
    },

    /**
     * Get timezone label
     * @returns {string}
     */
    getTimezoneLabel() {
      return getTimezoneLabel(this.timezone)
    },

    /**
     * Check if timestamp is ISO format (not duration)
     * @param {string} timestamp
     * @returns {boolean}
     */
    isISOTimestamp(timestamp) {
      if (!timestamp) return false
      if (typeof timestamp !== 'string') return false
      
      // Duration format: HH:MM:SS.mmm
      if (timestamp.match(/^\d{2}:\d{2}:\d{2}/)) return false
      
      // Try to parse as Date
      const date = new Date(timestamp)
      return !isNaN(date.getTime())
    },
  },
}

